'use client';

import useLoginModal from "@/app/hooks/useLoginModal";
import useAddProduct from "@/app/hooks/useAddProduct";
import React from "react";

interface AddProductButtonProps {
    userId?: string | null;
}

const AddProductButton: React.FC<AddProductButtonProps> = ({
    userId
}) => {
    const login = useLoginModal();
    const addProduct = useAddProduct();

    const yourHome = () => {
        if (userId) {
            addProduct.open()
        } else {
            login.open();
        }
    }
    return (
        <div 
            onClick={yourHome}
            className="cursor-pointer p-2 py-1 text-sm font-semibold rounded-full hover:bg-gray-200"
        >
            Show
        </div>
    )
}

export default AddProductButton;